import React, { useState, useEffect } from "react";
import { sharedData } from "../sharedData/sharedData";
import querySocketManager from "../socket/SocketManager";
import { formatDateForQuery } from "../utils/utils";
import config from "../config/config";
import { Select } from "./ui/Select";
import { MentionInputBox } from "./ui/MentionInputBox";
import CommentForm from "./forms/query-view/CommentForm";
import { userSession } from "../observers/userObserver";

const QueryView = ({ queryId, queryStatus, onBack }) => {
  const [comments, setComments] = useState([]);
  const [query, setQuery] = useState(null);
  const [newComment, setNewComment] = useState("");
  const [status, setStatus] = useState(queryStatus || "open");

  const requestId = sharedData.get("requestId");
  const token = userSession.getToken()

  const handleAddComment = async () => {

    if (newComment === `Query closed by ${localStorage.getItem('userName')}`) {
      await statusChange("closed");
      onBack();
      return;
    }

    try {
      const new_payload = {
        query_id: queryId,
        content: newComment,
      };
      const res = await fetch(`${config["backend-url"]}/add_comment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(new_payload),
      });
      const data = await res.json();
      console.log("Comment added:", data);
      setNewComment(""); // Clear input
    } catch (error) {
      console.error("Failed to add comment:", error);
    }
  };

  useEffect(() => {
    if (!requestId || !token || !queryId) return;

    // Fetch query details + comments
    const fetchQueryDetails = async () => {
      try {
        const res = await fetch(`${config["backend-url"]}/get_query/${queryId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        console.log("Query details:", data);
        setQuery(data.query);
      } catch (error) {
        console.error("Failed to fetch query:", error);
      }
    };

    const fetchComments = async () => {
      try {
        const res = await fetch(`${config["backend-url"]}/get_comments/${queryId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        console.log("Comments:", data);
        setComments(data.comments || []);
      } catch (error) {
        console.error("Failed to fetch comments:", error);
      }
    };

    fetchQueryDetails();
    fetchComments();

    // Connect to socket
    querySocketManager.connect(requestId, token, queryId, (socket) => {
      querySocketManager.on(
        "notify_new_comment",
        (data) => {
          console.log("New comment notification:", data);
          setComments((prev) => [data, ...prev]);
        },
        requestId,
        queryId
      );
    });

    return () => {
      // querySocketManager.off("comment_added", requestId, queryId);
      // querySocketManager.leaveRoom(requestId, token, queryId);
      // querySocketManager.disconnect(requestId, queryId);
    };
  }, []);

  const handleStatusChange = async (e) => {
    const newStatus = e.target.value;
    if (newStatus === "closed") {
      setNewComment(`Query closed by ${localStorage.getItem('userName')}`);
    }
  }

  const statusChange = async (value) => {
    setStatus(value);
    try {
      const res = await fetch(`${config["backend-url"]}/close_query/${queryId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      console.log("Status updated:", data);
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  if (!query) return <div>Loading query details...</div>;

  return (
    <div
      className="query-view"
      style={{
        padding: "20px",
        overflowY: "auto",
        maxHeight: "60vh",
        borderRadius: "8px",
      }}
    >
      <div
        className="query-header"
        
      >
        <div>
          <h2 style={{ margin: 0 }}>{query.subject}</h2>
        </div>
        <div>
          <Select
          label={"Status"}
          name={"status"}
          value={status}
          options={[
            { value: "open", display_value: "Open" },
            { value: "closed", display_value: "Closed" },
          ]}
          style={{ width: "120px" }}
          onChange={handleStatusChange}
        />
        </div>
      </div>
      <p className="query-description"><span className="query-description-head">Query Description:</span>{query.description}</p>

      {/* <h4 style={{ marginTop: "20px" }}>Comments:</h4>
      <ul
        className="comment-list"
        style={{ listStyleType: "none", padding: "0" }}
      >
        {comments.map((c, index) => (
          <li
            key={index}
            style={{
              marginBottom: "10px",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            <strong>{c.user_name}</strong>: {c.content}
            <div
              className="timestamp"
              style={{ fontSize: "0.8em", color: "#888" }}
            >
              {formatDateForQuery(c.timestamp)}
            </div>
          </li>
        ))}
      </ul> */}
      {comments.length > 0 && (
  <>
    <h4 style={{ marginTop: "10px",marginBottom: "10px" }}>Comments:</h4>
    <ul
      className="comment-list"
      style={{ listStyleType: "none", padding: "0" }}
    >
      {comments.map((c, index) => (
        <li
          key={index}
          style={{
            marginBottom: "10px",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        >
          <strong>{c.user_name}</strong>: {c.content}
          <div
            className="timestamp"
            style={{ fontSize: "0.8em", color: "#888" }}
          >
            {formatDateForQuery(c.timestamp)}
          </div>
        </li>
      ))}
    </ul>
  </>
)}
      <CommentForm
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        onSubmit={handleAddComment}
        onBack={onBack}
      />
    </div>
  );
};

export default QueryView;
